import { i18n } from '@apps/main/modules/localization/localizationSetup';
import { TripPlannerPax } from '@apps/main/modules/recipe/pax';

import type { Pax, RoomPax } from '@libs/trip-planner-interfaces';
import { getDomain } from '@libs/utils';

import { SessionStorageKey } from '../../models/sessionStorage';

const { t } = i18n.global;

export function getFormattedChildrenAges(pax: Pax): string | undefined {
  const tripPlannerPax = new TripPlannerPax(pax);
  if (!tripPlannerPax.formattedChildrenAges) {
    return;
  }
  const childrenAges = tripPlannerPax.formattedChildrenAges.split(',');
  const translationIndex =
    childrenAges.length === 1 && childrenAges[0] === '1' ? 1 : 2;

  return ` (${tripPlannerPax.formattedChildrenAges} ${t(
    'planner.pax.years',
    translationIndex
  ).toLowerCase()})`;
}

// NOTE: duplicated in formatting.ts
export function getFormattedPax(pax: Pax, detailed?: boolean): string {
  const tripPlannerPax = new TripPlannerPax(pax);
  let result: string;
  if (getDomain.isGermanMarket) {
    result = tripPlannerPax.totalNumberOfChildren
      ? `${tripPlannerPax.totalNumberOfAdults} ${t(
          'planner.pax.adults_shorthand',
          tripPlannerPax.totalNumberOfAdults
        )}`
      : `${tripPlannerPax.totalNumberOfAdults} ${t(
          'planner.pax.adults',
          tripPlannerPax.totalNumberOfAdults
        )}`;
  } else {
    result = `${tripPlannerPax.totalNumberOfAdults} ${t(
      'planner.pax.adults',
      tripPlannerPax.totalNumberOfAdults
    ).toLowerCase()}`;
  }

  if (tripPlannerPax.totalNumberOfChildren) {
    result += `, ${tripPlannerPax.totalNumberOfChildren} ${t(
      'planner.pax.children',
      tripPlannerPax.totalNumberOfChildren
    ).toLowerCase()}`;

    if (detailed) {
      result += ` (${tripPlannerPax.formattedChildrenAges})`;
    }
  }

  return result;
}

export function savePaxInKeyValueStorage(
  rooms: RoomPax[],
  setItem: (key: SessionStorageKey, value: string) => void
): void {
  try {
    const marketplacePax: Pax = rooms.map((room) => {
      const childAges = room.childAges ?? [];
      return {
        numberOfAdults: room.numberOfAdults,
        childAges,
        numberOfChildren: childAges.length,
      };
    });

    const marketplacePaxText = JSON.stringify(marketplacePax);
    setItem(SessionStorageKey.LatestPaxConfig, marketplacePaxText);
  } catch {
    throw new Error('Cannot serialize paxes!');
  }
}
